import React, { Component } from 'react';
import Button from '../utility/Button';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { postContactUsForm } from '../../actions/reviews';
import { withRouter } from 'react-router-dom';
import Cookies from 'js-cookie';

class ContactForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phone: '',
      enquiry: '',
      subject: 'Compliment',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    const xsrf = decodeURIComponent(Cookies.get('XSRF-TOKEN'));
    const response = await postContactUsForm(this.state, xsrf);
    event.preventDefault();
    if (response.status === 'success'){
      this.props.history.push(process.env.THANK_YOU_URL);
    }
    else if (response.status === 'failed'){
      alert(response.message);
    }else{
      alert('Something went wrong. Could not send the email');
    }
  }

  render() {
    const { name, email, phone, enquiry, subject } = this.state;
    const { t } = this.props;
    return(
      <div className="fe-contact-form-container">
        <form
          id="fe-contact-form"
          onSubmit={this.handleSubmit}
          // action={process.env.CONTACT_FORM_POST_URL}
          // action="https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8"
          // action="https://postman-echo.com/post"
          className="fe-contact-form"
          // method="POST"
        >
          <input
            type="hidden"
            name="orgid"
            //value="00D90000000fyKY"
            value={process.env.CONTACT_FORM_ORG_ID}
          />
          <input type="hidden" name="retURL" value={process.env.THANK_YOU_URL} />
          <div className="fe-contact-form-field">
            <label htmlFor="name">{t('form:name')}</label>
            {/* <input id="name" name="00N90000004Vi99" type="text" required /> */}
            <input id="name" name="name" type="text" value={name} onChange={this.handleChange} required />
          </div>
          <div className="fe-contact-form-field">
            <label htmlFor="email">{t('form:email')}</label>
            {/* <input id="email" name="00N90000004Vi9J" type="email" pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" required /> */}
            <input id="email" name="email" type="email" value={email} onChange={this.handleChange} pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" required />
          </div>
          <div className="fe-contact-form-field">
            <label htmlFor="phone">{t('form:phone')}</label>
            {/* <input id="phone" name="00N90000004Vi9W" type="tel" pattern="[0-9]{9,11}" required /> */}
            <input id="phone" name="phone" type="tel" value={phone} onChange={this.handleChange} pattern="[0-9]{9,11}" required />
          </div>
          <div className="fe-contact-form-field">
            <label htmlFor="subject">{t('support:subject')}</label>
            {/* <select
              className="fe-u-select custom-select"
              id="subject"
              name="subject"
              required
              value={subject}
              onChange={this.handleChange}
            > */}
            <select
              className="fe-u-select custom-select"
              id="subject"
              name="subject"
              required
              value={subject}
              onChange={this.handleChange}
            >
              <option value="General Enquiry">{t('support:generalEnquiry')}</option>
              <option value="Booking Enquiry">{t('support:bookingEnquiry')}</option>
              <option value="Feedback">{t('support:feedback')}</option>
              <option value="Compliment">{t('support:compliment')}</option>
              <option value="Complaint">{t('support:complaint')}</option>
              <option value="Join as Experience Provider">{t('support:joinAsExperienceProvider')}</option>
            </select>
          </div>
          <div className="fe-contact-form-field full">
            <label htmlFor="enquiry">{t('support:enquiry')}</label>
            {/* <textarea
              rows="5"
              id="enquiry"
              name="enquiry"
              type="text"
              value={enquiry}
              onChange={this.handleChange}
              required
            /> */}
            <textarea
              rows="5"
              id="enquiry"
              name="enquiry"
              type="text"
              value={enquiry}
              onChange={this.handleChange}
              required
            />
          </div>
          <div className="fe-contact-form-field full">
            <Button type="submit">
              {t('form:submit')}
            </Button>
          </div>
          <input type="hidden" id="external" name="external" value="1" />
          <input type="hidden" id="subject" name="subject" value={`Ford Getaways: ${subject}`} />
          <input type="hidden" id="description" name="description" value={enquiry} />
          <input type="hidden" id="status" name="status" value="New" />
          <input type="hidden" id="priority" name="priority" value="N/A" />
          <input type="hidden" id="type" name="type" value="General Enquiry" />
          <input type="hidden" id="recordType" name="recordType" value="01290000000SHla" />
          <input type="hidden" id="reason" name="reason" value="Others" />
          <input type="hidden" id="00N90000004Vi9R" name="00N90000004Vi9R" value="" />
          <input type="hidden" id="00N90000004Vlyo" name="00N90000004Vlyo" value="Ford" />
          <input type="hidden" id="00N90000004Vi9I" name="00N90000004Vi9I" value="1" />
          <input type="hidden" id="00N90000004Vi9G" name="00N90000004Vi9G" value="Customer Care Center" />
        </form>
      </div>
    );
  }
}

ContactForm.propTypes = {
  history: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withRouter(withTranslation()(ContactForm));

